<template>
    <main id="home-wrapper">
        <div v-if="loader" class="loading loading-double"></div>
        <div v-else id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: '/', status: false },
                    { title: 'Event', url: app_url+'/event', status: false },
                    { title: event.name, url: event.detail_url_web, status: false },
                    { title: schedule.name, url: event.detail_url_web+'/'+schedule.slug+'/registration', status: true }
                ]"
            ></breadcrumb>

            <section id="headline-events" class="section withPad blackBg">
                <div class="container">
                    <event-form :model_id="event.id" :model="event"  :modelschedule="schedule" :endpoint="api_url+'/event-registration'" :form_url="api_url+'/event-registration-form?model_id='+event.id" :member="user"></event-form>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import EventForm from "../event/EventForm";
import { isMobile } from "mobile-device-detect";

export default {
    components: {
        breadcrumb: BreadCrumb,
        'event-form' : EventForm
    },
    data() {
        return {
            loader:true,
            base_url:'',
            app_url:'',
            api_url:'',
            show: false,
            schedule:null,
            mobile: false,
            event: null,
            user:null,
            token:null,
            joinEventsClick:false,
            headers : null,
            form: new Form({
                    _token:token,
                    event_id:'',
                    schedule_id:'',
                }),
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getEventDetail();
    },
    methods: {
        getEventDetail() {
            this.loader = true;
            axios.get(api_url+'/event-detail/'+this.$route.params.slug)
                .then(response => {
                    this.event = response.data.data.eventDetail;
                    this.schedule = this.event.schedules.find(s => s.slug === this.$route.params.schedule);
                    if(this.schedule.is_join){
                        window.location.href = this.app_url + '/event/'+this.event.slug;
                    }
                    this.loader = false;
                }).catch(error => {
                    console.log(error);
                });
        },
    }
};
</script>

<style scoped lang="scss">
.bblack{
    background: #161616;
}
.joinEvent:hover{
    color:#fff;
    border:solid 1px #000;
    background: #333;
    text-decoration: none;
}
.joinEvent{
    cursor: pointer;
}
.img-promo-section-event {
    border-radius: 0px;
    float: right;
    overflow: hidden;
    img {
        max-width: 100%;
    }
}

.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.btn-share {
    position: relative;
}
.btn-share a {
    margin-top: 0;
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    background-color: transparent;
}
.btn-share a:hover {
    background-color: #e61b33;
    color: #fff;
}
.active .shares {
    width: 150px;
    left: 42px;
}
.active .shares {
    width: 150px;
}
.active .sharebtn {
    color: #999;
    background-color: #f2f2f2;
}
.shares {
    position: absolute;
    bottom: 0;
    left: 35px;
    height: 35px;
    width: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    a {
        margin: 0 4px;
    }
}
.offset-section {
    padding-left: 7em;
}
.list-logo .row-grid {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
}
.group_icon_detail .wrap-label  p{
    margin:0;
}
#headline-events .col-grid-50.flex_align_center {
    display: flex;
    flex: 1;
    align-items: center;
}
#row-middle-events {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid rgba(219, 219, 219, 0.1);
    border-bottom: 1px solid rgba(219, 219, 219, 0.1);
}
.flex-beetwen {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.isi-event h3 {
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
}
.isi-event p {
    font-weight: 300;
    font-size: 15px;
    color: #b4b4b4;
}
.schedule-list{
    display: flex;
    align-items: center;
    color:#fff;
    padding:30px 0;
    border-bottom:solid 1px #333;
    h3{
        font-size: 20px;
    }
    .right-button{
        margin-left:auto;
    }
}
.schedule-list:last-child{
    border:none;
}
@media all and (max-width: 767px) {
    .title_headline h3,
    .title-promo h2 {
        font-size: 24px;
    }
    img-promo-section-event {
        margin-bottom: 25px;
    }
    .content-promo-section {
        padding-right: 5px;
        padding-left: 5px;
        margin-bottom: 15px;
    }
    .title-promo {
        margin-top: 20px;
    }
}
</style>
